// Its own `user_welcome_flow` row (see welcomeFlowShared.ts): the row means the card has been shown
// at least once, and `completedAt` on it means the user answered.
export const PLATFORM_REVIEW_FLOW_KEY = "platform-review-2026-09";

// The card never opens before this fixed date, and never within 7 days of finishing the tour.
export const PLATFORM_REVIEW_SHOW_FROM = new Date("2026-09-18T00:00:00Z");
export const PLATFORM_REVIEW_MIN_GAP_MS = 7 * 24 * 60 * 60 * 1000;

// The cross writes this row and the card never returns. A card merely left open writes nothing, so it
// comes back on a later visit, PLATFORM_REVIEW_MAX_SHOWS times in all.
export const PLATFORM_REVIEW_NOT_NOW_KEY = `${PLATFORM_REVIEW_FLOW_KEY}:not-now`;
export const PLATFORM_REVIEW_MAX_SHOWS = 3;

/** One `user_welcome_flow` key per showing: the flow key itself for the first, `…:shown:N` after it. */
export const PLATFORM_REVIEW_SHOW_KEYS: readonly string[] = [
  PLATFORM_REVIEW_FLOW_KEY,
  ...Array.from({ length: PLATFORM_REVIEW_MAX_SHOWS - 1 }, (_, index) => `${PLATFORM_REVIEW_FLOW_KEY}:shown:${index + 2}`),
];
